(() => {
  const HOST_SELECTOR = 'pandectes-cmp';
  const STYLE_ID = 'cw-pandectes-glass-styles';

  const styles = `
    :host {
      --font-family: "Inter", Arial, sans-serif !important;
      --font-size: 15px !important;
      --padding: 0px !important;
      --radius-dialog: 14px !important;
      --radius-button: 6px !important;
      --border-button: 1px !important;
      --font-weight-button: 500 !important;
      --shadow-dialog: 0 24px 70px rgba(0, 0, 0, .22) !important;
      --color-base-100: rgba(248, 248, 246, .62) !important;
      --color-base-content: #111111 !important;
      --color-primary: #000000 !important;
      --color-primary-content: #ffffff !important;
      --color-secondary: #d8d8d5 !important;
      --color-secondary-content: #111111 !important;
    }

    .dialog {
      width: min(360px, calc(100vw - 32px)) !important;
      max-width: 360px !important;
      overflow: hidden !important;
      border: 1px solid rgba(255, 255, 255, .68) !important;
      border-radius: 10px !important;
      background: rgba(248, 248, 246, .84) !important;
      box-shadow: 0 18px 52px rgba(0, 0, 0, .16) !important;
      color: #111111 !important;
      -webkit-backdrop-filter: blur(24px) saturate(135%) !important;
      backdrop-filter: blur(24px) saturate(135%) !important;
    }

    .dialog::before {
      content: "" !important;
      position: absolute !important;
      inset: 0 0 auto 0 !important;
      z-index: 0 !important;
      height: 42% !important;
      pointer-events: none !important;
      background: linear-gradient(180deg, rgba(255, 255, 255, .30), transparent) !important;
    }

    .inner {
      position: relative !important;
      z-index: 1 !important;
      font-family: "Inter", Arial, sans-serif !important;
    }

    .header {
      gap: 10px !important;
      padding: 22px 22px 0 !important;
    }

    .header > h2 {
      gap: 10px !important;
      color: #111111 !important;
      font-family: "Inter", Arial, sans-serif !important;
      font-size: 16px !important;
      font-weight: 500 !important;
      line-height: 1.25 !important;
      letter-spacing: -.02em !important;
      text-transform: none !important;
    }

    .header > h2 > .logo,
    .header > h2 > div.logo {
      width: 26px !important;
      height: 26px !important;
      flex: 0 0 26px !important;
    }

    .body {
      padding: 18px 22px 0 !important;
      color: #333333 !important;
      font-family: "Inter", Arial, sans-serif !important;
      font-size: 13px !important;
      font-weight: 400 !important;
      line-height: 1.55 !important;
      letter-spacing: 0 !important;
    }

    .body p {
      margin: 0 !important;
      color: inherit !important;
      font: inherit !important;
      line-height: inherit !important;
    }

    div.actions {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
      gap: 8px !important;
      padding: 22px !important;
      border: 0 !important;
      background: transparent !important;
    }

    div.actions button {
      width: 100% !important;
      min-width: 0 !important;
      min-height: 46px !important;
      margin: 0 !important;
      padding: 0 14px !important;
      border-width: 1px !important;
      border-radius: 4px !important;
      box-shadow: none !important;
      font-family: "Inter", Arial, sans-serif !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      line-height: 1 !important;
      letter-spacing: 0 !important;
      text-transform: none !important;
    }

    div.actions button.primary.filled {
      border-color: #000000 !important;
      background: #000000 !important;
      color: #ffffff !important;
    }

    div.actions button.secondary.filled {
      border-color: rgba(17, 17, 17, .18) !important;
      background: rgba(255, 255, 255, .42) !important;\n      -webkit-backdrop-filter: blur(12px) !important;\n      backdrop-filter: blur(12px) !important;
      color: #111111 !important;
    }

    div.actions button.outlined {
      grid-column: 1 / -1 !important;
      min-height: 36px !important;
      border-color: transparent !important;
      background: transparent !important;
      color: #555555 !important;
      text-decoration: underline !important;
      text-decoration-thickness: 1px !important;
      text-underline-offset: 4px !important;
    }

    div.actions button:hover {
      opacity: 1 !important;
    }

    div.actions button.primary.filled:hover {
      border-color: #242424 !important;
      background: #242424 !important;
    }

    div.actions button.secondary.filled:hover {
      background: rgba(255, 255, 255, .82) !important;
    }

    div.actions button.outlined:hover {
      color: #111111 !important;
    }

    div.actions button:focus-visible {
      outline: 2px solid #111111 !important;
      outline-offset: 3px !important;
    }

    @media (max-width: 359px) {
      .dialog {
        width: calc(100vw - 24px) !important;
        border-radius: 8px !important;
      }

      div.actions {
        grid-template-columns: 1fr !important;
        padding: 20px !important;
      }

      div.actions button.outlined {
        grid-column: auto !important;
      }

      .header {
        padding: 20px 20px 0 !important;
      }

      .body {
        padding: 16px 20px 0 !important;
      }
    }

    @supports not ((-webkit-backdrop-filter: blur(1px)) or (backdrop-filter: blur(1px))) {
      .dialog {
        background: rgba(250, 250, 248, .98) !important;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .dialog,
      div.actions button {
        animation: none !important;
        transition: none !important;
      }
    }

    /* High-contrast smoked glass variant */
    :host {
      --color-base-100: rgba(24, 24, 24, .62) !important;
      --color-base-content: #ffffff !important;
      --color-primary: #ffffff !important;
      --color-primary-content: #111111 !important;
      --color-secondary: rgba(255, 255, 255, .16) !important;
      --color-secondary-content: #ffffff !important;
    }

    .dialog {
      border: 1px solid rgba(255, 255, 255, .34) !important;
      background:
        linear-gradient(135deg, rgba(55, 55, 55, .68), rgba(15, 15, 15, .50)) !important;
      box-shadow:
        0 28px 80px rgba(0, 0, 0, .34),
        inset 0 1px 0 rgba(255, 255, 255, .28),
        inset 0 0 0 1px rgba(255, 255, 255, .05) !important;
      color: #ffffff !important;
      -webkit-backdrop-filter: blur(28px) saturate(155%) contrast(112%) !important;
      backdrop-filter: blur(28px) saturate(155%) contrast(112%) !important;
    }

    .dialog::before {
      height: 52% !important;
      background:
        radial-gradient(circle at 18% 0%, rgba(255, 255, 255, .22), transparent 52%),
        linear-gradient(180deg, rgba(255, 255, 255, .10), transparent) !important;
    }

    .header > h2 {
      color: #ffffff !important;
    }

    .header > h2 > div.logo {
      background-color: #ffffff !important;
    }

    .body {
      color: rgba(255, 255, 255, .82) !important;
    }

    div.actions button.primary.filled {
      border-color: #ffffff !important;
      background: #ffffff !important;
      color: #111111 !important;
      box-shadow: 0 8px 22px rgba(0, 0, 0, .18) !important;
    }

    div.actions button.secondary.filled {
      border-color: rgba(255, 255, 255, .30) !important;
      background: rgba(255, 255, 255, .10) !important;
      color: #ffffff !important;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, .12) !important;
      -webkit-backdrop-filter: blur(12px) !important;
      backdrop-filter: blur(12px) !important;
    }

    div.actions button.outlined {
      border-color: transparent !important;
      background: transparent !important;
      color: rgba(255, 255, 255, .72) !important;
    }

    div.actions button.primary.filled:hover {
      border-color: #eeeeee !important;
      background: #eeeeee !important;
    }

    div.actions button.secondary.filled:hover {
      background: rgba(255, 255, 255, .18) !important;
    }

    div.actions button.outlined:hover {
      color: #ffffff !important;
    }

    div.actions button:focus-visible {
      outline-color: #ffffff !important;
    }

  `;

  function applyGlass(host) {
    if (!host || !host.shadowRoot || host.shadowRoot.getElementById(STYLE_ID)) return false;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = styles;
    host.shadowRoot.appendChild(style);
    return true;
  }

  function findAndApply() {
    document.querySelectorAll(HOST_SELECTOR).forEach(applyGlass);
  }

  findAndApply();

  const observer = new MutationObserver(findAndApply);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  let attempts = 0;
  const timer = window.setInterval(() => {
    findAndApply();
    attempts += 1;
    if (attempts >= 120) window.clearInterval(timer);
  }, 250);

  window.addEventListener('pagehide', () => {
    observer.disconnect();
    window.clearInterval(timer);
  }, { once: true });
})();